import { useState } from "react";
import FormComp from "../../../Componentes/FormComp";
import Overlay from "../../../Componentes/Overlay";
import Formulario from "../../../Componentes/Utils/Formulario";
import Modal from "../../../Componentes/Utils/Modal";
import styled from "styled-components";
import { useModal } from "../../../contexts/ModalContext";
import { formatBRLFromCents, parseCentsFromInput } from "../../../Funcoes/Money";

const Titulo = styled.h2`
    margin: 0 0 15px 0;
    font-size: 18px;
    color: #333;
`
const BotoesWrapper = styled.div`
    margin-top: 15px;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
`
const Botao = styled.button`
    padding: 9px 12px;
    background-color: ${props => props.cancel ? '#e5e7eb' : '#2563eb'};
    color: ${props => props.cancel ? '#333' : 'white'};
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: .2s all ease;
    &:hover {
        background-color: ${props => props.cancel ? '#d1d5db' : '#1d4ed8'};
    }
`

const ModalAddValorNF = ({ setListaNF }) => {

    const { closeModal } = useModal();

    const [valorNF, setValorNF] = useState({
        numNF: "",
        valorNF: 0
    })

    const handleSave = (e) => {

        e.preventDefault();
        setListaNF((prev) => [...prev, { ...valorNF, id: Date.now() }])
        closeModal();
    }

    return (
        <>
            <Overlay state={true} >
                <Modal size="sm" >
                    <Formulario onSubmit={handleSave} >
                        <Titulo>Adicionar valor à NF</Titulo>
                        <FormComp
                            title="NÚMERO NF"
                            type="text"
                            valor={valorNF.numNF}
                            changeFunc={(e) => setValorNF((prev) => ({ ...prev, numNF: e.target.value }))}
                        />
                        <FormComp
                            title="VALOR NF"
                            type="text"
                            valor={formatBRLFromCents(valorNF.valorNF)}
                            changeFunc={(e) => setValorNF((prev) => ({ ...prev, valorNF: parseCentsFromInput(e.target.value) }))}
                        />
                        <BotoesWrapper>
                            <Botao cancel type="button" onClick={closeModal} >CANCELAR</Botao>
                            <Botao type="submit" >ADICIONAR</Botao>
                        </BotoesWrapper>
                    </Formulario>
                </Modal>
            </Overlay>
        </>
    )
}

export default ModalAddValorNF;